import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import { media } from '../../../utils/style'
import IconClose from '../../../vectors/IconClose'

export const Bar = styled(
  ({
    theme,
    fg,
    bg,
    rounded,
    offer,
    error,
    finance,
    feedback,
    success,
    hidden,
    overlay,
    sticky,
    fixed,
    warning,
    ...rest
  }) => <Flex {...rest} />
)`
  position: relative;
  display: flex;
  ${(props) => (props.overlay ? 'position: absolute;' : '')}
  ${(props) => (props.sticky ? 'position: sticky;' : '')}
  ${(props) => (props.fixed ? 'position: fixed;' : '')}
  ${(props) => (props.sticky || props.fixed ? 'top: 0;' : '')}
  align-items: baseline;
  z-index: 2;
  line-height: 1.3;
  background-color: ${(props) => props.theme.colors[props.bg]};
  ${(props) =>
    props.error || props.error
      ? `background-color: ${props.theme.colors.red};`
      : ''}
  ${(props) =>
    props.offer || props.warning
      ? `background-color: ${props.theme.colors.green};`
      : ''}
  ${(props) =>
    props.finance || props.feedback || props.success
      ? `background-color: ${props.theme.colors.green};`
      : ''}
  color: ${(props) => props.fg};
  ${(props) => (props.rounded ? 'border-radius: 5px;' : '')}
  a {
    color: ${(props) => props.fg};
    font-weight: 600;
  }

  transition: transform 0.4s ${(props) => props.theme.ease.ease_in_out_circ},
    min-height 0.4s ${(props) => props.theme.ease.ease_in_out_circ} 0.1s,
    padding 0.2s ${(props) => props.theme.ease.ease_in_out_circ};
  transform-origin: top;
  ${(props) =>
    props.hidden ? 'transform: scaleY(0) translate3d(0, 0, 0);' : ''}
  ${(props) => (props.hidden ? 'min-height: 0;' : '')}
  ${(props) => (props.hidden ? 'height: 0;' : '')}
  ${(props) => (props.hidden ? 'padding: 0;' : '')}
  ${(props) => (props.hidden ? 'overflow: hidden;' : '')}
  svg, div {
    transition: opacity 0.25s ${(props) => props.theme.ease.ease_out_circ},
      transform 0.8s ${(props) => props.theme.ease.ease_out_circ};
    ${(props) =>
      props.hidden
        ? 'transform: translateY(-100%);'
        : 'transform: translateY(0);'}
    ${(props) => (props.hidden ? 'opacity: 0;' : '')}
  }
`

export const Content = styled(Box)`
  position: relative;
  z-index: 1;
  a {
    &:hover {
      color: rgba(66, 76, 94, 1);
    }
  }
`

export const Icons = styled(Box)`
  position: absolute;
  display: block;
  top: 50%;
  transform: translateY(-50%) !important;
  svg {
    display: inline-block;
    position: relative;
    transform: translateY(10%);
    path {
      fill: ${(props) => props.fg};
    }
  }
`

export const RightCentreIconClose = styled(IconClose)`
  cursor: pointer;
  position: absolute;
  display: block;
  z-index: 2;
  top: 50%;
  right: ${rem(10)};
  ${media.LargeScreenUp`
    right: ${rem(35)};
  `};
  transform: translateY(-50%) !important;
  path {
    fill: white;
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    transform: scale(0.45);
    transform-origin: center;
  }
  &:hover > path {
    fill: rgba(66, 76, 94, 1);
  }
`
RightCentreIconClose.displayName = 'RightCentreIconClose'
